let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5VLjt")).then(() => parcelRequire('kaSFD'));